var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3077 1.25732C11.0484 0.991487 10.7122 0.847793 10.3549 0.847793H9.77335C9.74533 0.380788 9.36 0 8.89761 0H5.92006C5.45766 0 5.07234 0.380788 5.04431 0.847793H4.45581C3.71317 0.847793 3.11066 1.46568 3.11066 2.23444V3.8941H1.36617C0.609521 3.8941 0 4.51917 0 5.29511V11.359C0 12.1277 0.609521 12.76 1.36617 12.76H5.9691C6.02515 12.76 6.0812 12.7456 6.15126 12.7384H10.3549C11.0975 12.7384 11.7 12.1206 11.7 11.3518V2.23444C11.7 1.86083 11.5599 1.51597 11.3077 1.25732ZM6.28437 11.359C6.28437 11.5027 6.18629 11.6248 6.06018 11.6607H5.17042L5.07934 11.6823H1.36617C1.19102 11.6823 1.0509 11.5314 1.0509 11.359V5.29511C1.0509 5.1155 1.19102 4.9718 1.36617 4.9718H5.9691C6.14425 4.9718 6.28437 5.1155 6.28437 5.29511V11.359ZM10.6491 11.3518C10.6491 11.5242 10.516 11.6607 10.3549 11.6607H7.30024C7.32126 11.553 7.33527 11.4524 7.33527 11.359V5.29511C7.33527 4.51917 6.72575 3.8941 5.9691 3.8941H4.16156V2.23444C4.16156 2.062 4.28766 1.9255 4.45581 1.9255H5.19144C5.35258 2.19133 5.62581 2.34939 5.92006 2.34939H8.89761C9.19186 2.34939 9.45808 2.19133 9.62623 1.9255H10.3549C10.516 1.9255 10.6491 2.062 10.6491 2.23444V11.3518Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/paste.2e60195bb1de4f4bfc4f641d5a2db71e.svg";
export { ForwardRef as ReactComponent };